import { render } from "./AddUserView.vue?vue&type=template&id=0b4495a4"
import script from "./AddUserView.vue?vue&type=script&lang=js"
export * from "./AddUserView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__